import type { AdminUiKey } from "./legacy/adminUi"
import type { GarageUiKey } from "./legacy/garageUi"
import type { AutoclanUiKey } from "./legacy/autoclanUi"

// Unofficial modern-UI adaptations; see SPECIAL_LANGUAGES_BEEPAPP.md.
export type SpecialLocale = "non" | "sjn" | "art-x-navi" | "art-x-huttese" | "art-x-hv"

export interface SpecialLocaleUi {
  admin: Record<AdminUiKey, string>
  garage: Record<GarageUiKey, string>
  autoclan: Record<AutoclanUiKey, string>
  plate: Record<"invalid" | "blocked000", string>
  activity: Record<"online" | "recent", string>
  extraSignals: Record<"profanity" | "mud" | "sawRoad" | "goodLuck" | "countryman" | "meet", string>
  signals: readonly string[]
  statuses: readonly (readonly [string, string?])[]
  preferences: Record<"saveError" | "chooseLanguage", string>
}

// Proper place names are retained in Latin spelling, not invented as new markets.
export const specialCountryNames = {
  "country.brazil": "Brasil", "country.vietnam": "Vietnam", "country.egypt": "Egypt",
  "country.india": "India", "country.indonesia": "Indonesia", "country.iran": "Iran",
  "country.spain": "España", "country.italy": "Italia", "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Colombia", "country.malaysia": "Malaysia", "country.mexico": "México",
  "country.nigeria": "Nigeria", "country.pakistan": "Pakistan", "country.russia": "Russia",
  "country.usa": "USA", "country.turkey": "Türkiye", "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine", "country.philippines": "Pilipinas",
} as const
